<template>
  <div class="product-mockups-preview">
    <!-- <carousel :perPage="1" ref="carousel">
      <slide
        v-for="(image, index) in images()"
        :key="index"
        :data-index="index"
      >
        <img v-if="image" :src="image" style="max-width:100%" />
      </slide>
      
    </carousel> -->
    <img v-if="images2()" :src="images2()" style="max-width:100%" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Mockup from './Mockup/Mockup'
import Media from './Media/Media'
import { Carousel, Slide } from 'vue-carousel'
import jQuery from 'jquery'

export default {
  components: {
    Mockup,
    Media,
    Carousel,
    Slide
  },
  data() {
    return {
      media: []
    }
  },
  computed: {
    ...mapGetters(['selectedVariant'])
  },
  methods: {
    base64ToBlobUrl(base64) {
      const byteString = atob(base64.split(',')[1]);
      const mimeString = base64.split(',')[0].split(':')[1].split(';')[0];
      const byteArray = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
          byteArray[i] = byteString.charCodeAt(i);
      }      
      const blob = new Blob([byteArray], { type: mimeString });
      const blobUrl = URL.createObjectURL(blob);
      return blobUrl;
    },
    images2(){
      var img = "";
      const canvas = document.querySelectorAll(`#om-product-carousels canvas`);
      if(canvas[0]){
        img = (canvas[0].toDataURL('image/jpeg'));
      }else{
        var urls = [];
        const imgsElement = document.querySelectorAll(`#om-product-carousels img`);
        for(var a = 0; a < imgsElement.length; a++){
          if(imgsElement[a].getAttribute('src')){
            urls = [...urls, imgsElement[a].getAttribute('src')];
          }
        }
        urls = urls.filter(e => e);
        if(urls.length <= 0) return img;
        img = urls[0];
      }
      return img;
    },
    images() {
      const { selectedVariant } = this
      var imgs = []
      var element = null
      jQuery(`#om-product-carousels [variant-ids*=${selectedVariant}]`).each(
        (_, el) => {
          element = el
          return false
        }
      )
      if (element === null) {
        jQuery(`#om-product-carousels [is-render=1]`).each((_, el) => {
          element = el
          return false
        })
      }
      if (element === null) {
        jQuery(`#om-product-carousels .VueCarousel-slide`).each((_, el) => {
          element = el
          return false
        })
      }
      if (element) {
        jQuery(element)
          .find('img, canvas')
          .each((_, el) => {
            if (jQuery(el).is('canvas')) {
              imgs.push(this.base64ToBlobUrl(el.toDataURL('image/jpeg')))
            } else {
              imgs.push(jQuery(el).attr('src'))
            }
          })
      }
      return imgs
    }
  }
}
</script>

<style scoped>
.product-mockups-preview {
  border-radius: 5px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Preview.vue